<template>
    <div name="notification-modal">
        <div class="modal">
            <div class="contents">
                <div class="row">
                    <span class="title">공지</span>
                    <span class="message">안녕하세요, 팀 솔닥입니다.<br>더 안정적인 서비스 제공을 위해 아래 시간 동안 시스템 점검이 진행될 예정입니다.<br><br>- 점검 일시: 2025.12.15 월요일 오후 21:00 ~ 22:00<br>- 영향 범위: 솔닥 컨시어지 마이페이지 이용 일시 제한<br><br>점검 시간 동안은 서비스 접속 및 이용이 어려울 수 있으며, 점검 완료 후 정상적으로 이용하실 수 있습니다.<br><br>보다 나은 서비스를 위해 최선을 다하겠습니다.<br>감사합니다.</span>
                </div>

                <div class="row" style="margin-top: 40px;">
                    <div class="button1" @click="neverViewAgain">다시 보지 않기</div>
                    <div class="button2" @click="close">닫기</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import cookies from '@/utilities/cookie';

export default {   
    name: 'notificationModal',
    mounted: function()
    {
        // is naver view again true, false 확인
        const flag = cookies.getLocalStorage("neveragain02");
        if(flag === null || flag === undefined || flag === false || flag === '')
        {
            
        }
        else
        {
            this.$emit('close')
        }

    },
    methods: {
        neverViewAgain: function()
        {   
            cookies.setLocalStorage("neveragain02", true);
            this.$emit('close')
        },
        close: function()
        {
            this.$emit('close')
        }
    }
}
</script>

<style scoped>
    .wrapper {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .modal {
        position: fixed;
        background: rgba(0, 0, 0, 0.7);
        max-width: 600px;
        width: 100%;
        height: 100vh;
        z-index: 11;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: flex-end;
    }
    .touch {
        width: 100vw;
    }
    .contents {
        background: #FFFFFF;
        width: calc(100%);
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
        padding: 34px 16px 30px 16px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;
        box-sizing: border-box;
    }

    .title {
        color: #1E1E1E;
        font-family: Pretendard;
        font-size: 24px;
        font-style: normal;
        font-weight: 500;
        line-height: 28px; /* 116.667% */
    }

    .message {
        color: #1E1E1E;
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 110% */
        margin-top: 20px;
    }
    .button1 {
        display: flex;
        width: 100%;
        height: 56px;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;
        border-radius: 6px;
        background: var(--Gray-100, #1E1E1E);
        color: var(--Gray-00, #FFF);
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        cursor: pointer;
    }
    .button2 {
        display: flex;
        width: 100%;
        height: 56px;
        justify-content: center;
        align-items: center;
        color: var(--Gray-100, #1E1E1E);
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        cursor: pointer;
    }
    .row {
        display: flex;
        flex-direction: column;
        width: 100%;
    }
</style>


// WEBPACK FOOTER //
// src/components/modals/NotificationModal.vue